<template>
  <div>
    <bar-chart-horizontal
      v-if="type === 'horizontal-bar'"
      :size="size"
      :chart-data="chartData"
    />

    <bar-chart-horizontal
      v-if="type === 'horizontal-bar-stacked'"
      :size="size"
      :stacked="true"
      :chart-data="chartData"
    />

    <pie-chart
      v-if="type === 'pie'"
      :size="size"
      :chart-data="chartData"
    />
  </div>
</template>

<script>
  const BarChartHorizontal = () => import(/* webpackChunkName: 'chart/horizontal-bar' */
    './BarChartHorizontal.vue')
  const PieChart = () => import(/* webpackChunkName: 'chart/pie-chart' */
    './PieChart.vue')

  export default {
    name: 'Chart',
    components: {
      BarChartHorizontal,
      PieChart
    },
    props: {
      type: {
        type: String,
        required: true,
        validator (type) {
          return [
            'horizontal-bar',
            'horizontal-bar-stacked',
            'pie'
          ].indexOf(type) !== -1
        }
      },
      chartData: {
        type: Object,
        required: true,
        default: () => {}
      },
      size: {
        type: String,
        required: false,
        default: 'medium'
      }
    }
  }
</script>
